import React from 'react'
import { context as ___context } from "@fyne/ui/context";
export const context = ___context
export const FyneContext = React.createContext(context);
